import { Component } from '@angular/core';

@Component({
  selector: 'app-how-henter-pant-works',
  templateUrl: './how-henter-pant-works.component.html',
  styleUrl: './how-henter-pant-works.component.scss'
})
export class HowHenterPantWorksComponent {}

